import { render, staticRenderFns } from "./PublicPolicy.vue?vue&type=template&id=1785c62b&scoped=true&"
import script from "./PublicPolicy.vue?vue&type=script&lang=js&"
export * from "./PublicPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785c62b",
  null
  
)

export default component.exports